import { inject, injectable } from 'inversify'
import Debug from 'debug'
import { PlayerModule } from '../api'
import { FetchServiceSymbol, FetchErrorNotificationServiceSymbol } from './service'
import { FunctionRetryStrategy, logaritmicRetryFunction, FetchService, FetchErrorNotificationService } from '@xlearn/async-toolbox'

const debug = Debug('fetch-player-module')

@injectable()
export class FetchPlayerModule implements PlayerModule {

  readonly name = 'fetch'
  
  constructor(
    @inject(FetchServiceSymbol)
    private fetchService: FetchService,
    @inject(FetchErrorNotificationServiceSymbol)
    private fetchNotificationService: FetchErrorNotificationService) {}

  init(): void {
    debug('init');

    const basePath = ''
    this.fetchService.start(basePath, new FunctionRetryStrategy(
      logaritmicRetryFunction({ initialDelayMs: 500, delayAt10thRetryMs: 3000 })))
    this.fetchNotificationService.start()
  }

  start(): void {
  }

  reset(): void {

  }

  async stop() {
    debug('stop')

    await this.fetchService.stop({ cancel: true })
    await this.fetchNotificationService.stop()
  }
}
